import React from "react";
import { Modal, ModalBody, Button, Spinner } from "reactstrap";

// Confirmação de uma ação sobre a fatura IUGU da venda (nova fatura, pagamento offline):
// ícone, explicação, fatura atual e ações "Voltar" / confirmar, com spinner enquanto processa.
export default function ModalInvoiceAction({
  isOpen,
  toggle,
  processorId,
  loading,
  onConfirm,
  title,
  description,
  note,
  confirmLabel,
  icon,
  tone = "warning",
  color = "primary",
}) {
  return (
    <Modal
      isOpen={isOpen}
      toggle={loading ? undefined : toggle}
      centered
      contentClassName="border-0 shadow-lg modal-cancel-sale"
    >
      <ModalBody className="p-4 text-center">
        <span
          className={`avatar-title rounded-circle bg-${tone} bg-soft text-${tone} mx-auto mb-3`}
          style={{ width: 64, height: 64 }}
        >
          <i className={`mdi ${icon} font-size-24`} aria-hidden="true" />
        </span>

        <h5 className="mb-1">{title}</h5>
        <p className="text-muted mb-3">{description}</p>

        <div className="bg-light rounded-3 text-start px-3 py-2 mb-3 font-size-13">
          <div className="d-flex align-items-baseline gap-2">
            <span className="text-muted flex-shrink-0">Fatura atual</span>
            <span className="fw-semibold font-monospace text-break">
              {processorId}
            </span>
          </div>
        </div>

        {note && (
          <p className="text-muted font-size-13 mb-4">
            <i className="mdi mdi-information-outline me-1" aria-hidden="true" />
            {note}
          </p>
        )}

        <div className="d-flex justify-content-center gap-2">
          <Button
            color="light"
            className="px-4"
            onClick={toggle}
            disabled={loading}
          >
            Voltar
          </Button>
          <Button
            color={color}
            className="px-4 d-inline-flex align-items-center gap-2"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading && <Spinner size="sm" />}
            {confirmLabel}
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
}
